module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"preview":"比較プレビュー","close":"閉じる","difference":"差の絶対値","defferenceDesc":"オリジナル画像と変換後の画像の差分を画像で表現したものです。2枚の画像に差分がない場合は黒一色になります。","horizontalDiff":"画像の差分(横並び)","verticalDiff":"画像の差分(縦並び)","slider":"スライダー","sliderDesc":"バーをスライドして変換前後の画像を比較できます。"}}')
  delete Component.options._Ctor
}
